<div style="padding-bottom: 15px">
  @if (mixedLayers$ | async; as layers) {
    <div class="layer-panel-body">
      @for (item of layers; track item) {
        <!-- Grouped layers -->
        @if (item.isGroup) {
          <atlas-layer-group
            [group]="item"
            [layersExpandedDictionary]="layersExpandedDictionary"
            [layerExpandedState]="layersExpandedDictionary.get(item.id)"
          (layerExpandedStateChanged)="
            onLayerExpandedStateChanged(item.id, $event)
          "
            >
          </atlas-layer-group>
        } @else {
          <atlas-layer-legend
            [layer]="item"
            [layerExpandedState]="layersExpandedDictionary.get(item.id)"
          (layerExpandedStateChanged)="
            onLayerExpandedStateChanged(item.id, $event)
          "
            >
          </atlas-layer-legend>
        }
        <!-- Standard ungrouped layer -->
      }
      <div>
        <atlas-base-map-layer-collection
          [initialBaseMapLayerType]="initialBaseMapLayerType"
          >
        </atlas-base-map-layer-collection>
      </div>
    </div>
  }
</div>
